/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Subject_Physics14Inputs */

const en__field_enum_subject_physics14 = /** @type {(inputs: _Field_Enum_Subject_Physics14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Physics`)
};

const de__field_enum_subject_physics14 = /** @type {(inputs: _Field_Enum_Subject_Physics14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Physik`)
};

/**
* | output |
* | --- |
* | "Physics" |
*
* @param {_Field_Enum_Subject_Physics14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_subject_physics14 = /** @type {((inputs?: _Field_Enum_Subject_Physics14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Subject_Physics14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_subject_physics14(inputs)
	return de__field_enum_subject_physics14(inputs)
});
export { _field_enum_subject_physics14 as "_field_enum_SUBJECT_PHYSICS" }